import { storyblokEditable } from "@storyblok/react";
import CollectionLink from "./CollectionLink";

function CollectionList3({ blok }) {
  if (!blok) return null;

  return (
    <section
      key={blok._uid}
      {...storyblokEditable(blok)}
      className="container storyblok-collection-list-3"
    >
      <div className="row">
        <div className="d-lg-none pb-4 mb-2">
          <div className="pb-4 d-flex gap-3">
            <CollectionLink
              className="collection-list-3-left"
              title={blok.collection_list_3_left_title}
              collectionLink={blok.collection_list_3_left_link?.url}
              src={blok.collection_list_3_left_image?.filename}
              alt={`${blok.collection_list_3_left_title} image`}
              trackingName="collectionList3"
            />
            <CollectionLink
              className="collection-list-3-right"
              title={blok.collection_list_3_right_title}
              collectionLink={blok.collection_list_3_right_link?.url}
              src={blok.collection_list_3_right_image?.filename}
              alt={`${blok.collection_list_3_right_title} image`}
              trackingName="collectionList3"
            />
          </div>
          <CollectionLink
            className="collection-list-3-hero"
            title={blok.collection_list_3_hero_title}
            collectionLink={blok.collection_list_3_hero_link?.url}
            src={blok.collection_list_3_hero_image?.filename}
            alt={`${blok.collection_list_3_hero_title} image`}
            trackingName="collectionList3"
          />
        </div>

        <div className="d-none d-lg-flex pb-5">
          <div className="d-flex w-100 gap-3">
            <CollectionLink
              className="collection-list-3-left"
              title={blok.collection_list_3_left_title}
              collectionLink={blok.collection_list_3_left_link?.url}
              src={blok.collection_list_3_left_image?.filename}
              alt={`${blok.collection_list_3_left_title} image`}
              trackingName="collectionList3"
            />
            <CollectionLink
              className="collection-list-3-hero"
              title={blok.collection_list_3_hero_title}
              collectionLink={blok.collection_list_3_hero_link?.url}
              src={blok.collection_list_3_hero_image?.filename}
              alt={`${blok.collection_list_3_hero_title} image`}
              trackingName="collectionList3"
            />
            <CollectionLink
              className="collection-list-3-right"
              title={blok.collection_list_3_right_title}
              collectionLink={blok.collection_list_3_right_link?.url}
              src={blok.collection_list_3_right_image?.filename}
              alt={`${blok.collection_list_3_right_title} image`}
              trackingName="collectionList3"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default CollectionList3;
